import { t } from 'i18next'
import { z } from 'zod'

import { DateTime } from '@/modules/shared/schemas/DateTime'

import { Ticket, TicketStatus } from './Ticket'
import { TicketAttachmentType } from './TicketDetails'

//TODO - criar paginação com modelo zod
export const DashboardTicket = z.object({
  status: z.array(z.object({ status: TicketStatus, amount: z.number() })),
  tickets: z.object({
    content: z.array(Ticket),
    size: z.number().optional(),
    totalElements: z.number().optional(),
    totalPages: z.number().optional(),
    page: z.number().optional()
  })
})
export type DashboardTicket = z.infer<typeof DashboardTicket>

export const CreateTicketDTO = z.object({
  description: z.string().min(1, t('general.form.required')),
  patientId: z.string().nullable(),
  areaId: z.string().min(1, t('general.form.required')),
  subAreaId: z.string().min(1, t('general.form.required')),
  attachment: z.object({
    ticketAttachmentId: z.string().min(1, t('general.form.required')),
    attachmentType: TicketAttachmentType
  })
})
export type CreateTicketDTO = z.infer<typeof CreateTicketDTO>

export const DashboardTicketDTO = z.object({
  date: DateTime.optional(),
  areaId: z.string().optional(),
  subAreaId: z.string().optional(),
  responsible: z.string().optional(),
  status: z.array(TicketStatus).optional(),
  page: z.number().optional(),
  size: z.number().optional(),
  month: z.number().optional(),
  year: z.number().optional()
})
export type DashboardTicketDTO = z.infer<typeof DashboardTicketDTO>
